export enum UserRole {
  expert = "Expert",
  client = "Client",
  clientAdmin = "ClientAdmin",
  arbolusTeam = "ArbolusTeam",
  guest = "Guest"
}
